import { render, staticRenderFns } from "./PabloRamos.vue?vue&type=template&id=bee10d4c&scoped=true"
import script from "./PabloRamos.vue?vue&type=script&lang=js"
export * from "./PabloRamos.vue?vue&type=script&lang=js"
import style0 from "./PabloRamos.vue?vue&type=style&index=0&id=bee10d4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee10d4c",
  null
  
)

export default component.exports